function setParentHeight() {
    const mobileMaxWidth = 640;
    const minparentHeightDesktop = 490;
    const minparentHeightMobile = 394;
    const parent = document.getElementsByClassName("hero-block-container");

    for (let i = 0; i < parent.length; i++) {
        let parentTochange = parent[i];
        let childdivNode = parentTochange.children;

        for (let j = 0; j < childdivNode.length; j++) {
            if (childdivNode[j].className.match("hero-block-container__data-container")) {
                let childDiv = childdivNode[j];
                let newHeight = 0;
                let screenWidth = window.innerWidth;
                let childHeight = 0;

                childHeight = childDiv.offsetHeight;
                let parentHeight = 0;
                if (screenWidth < mobileMaxWidth) {
                    parentHeight = childHeight + 130;
                    newHeight = parentHeight > minparentHeightMobile ? parentHeight : minparentHeightMobile;
                    parentTochange.style.height = parentHeight + 'px';
                } else {
                    parentHeight = childHeight + 200;
                    newHeight = parentHeight > minparentHeightDesktop ? parentHeight : minparentHeightDesktop;
                    parentTochange.style.height = parentHeight + 'px';
                }
            }
        }
    }
}

window.addEventListener("load", (event) => {
    setParentHeight();
});

window.addEventListener("resize", (event) => {
    setParentHeight();
});

